module.exports = __webpack_public_path__ + "img/update-arrows-svgrepo-com 1refresh.bbfc866c.svg";